import React, { useEffect, useRef, useMemo, useCallback } from 'react'
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from 'react-sortable-hoc'
import { findIndex } from 'lodash-es'
import { ListStoreProvider } from '@ow/ditto-core'
import useDittoSelected from '../hooks/use-ditto-selected'
import BaseTable from './basetable/BaseTable'
import AutoResizer from './basetable/AutoResizer'
import DragHandle from './basetable/DragHandle'
import Renders from './renders/excelike'

import BaseTableStyld from './basetable/styled/baseTable'
import nullData from '../assets/null.png'

import {
  transformTableFieldsDefs,
  transformMergeCellInfo,
  calculationMergeCellInfo,
} from './utils'

const RenderNullData = () => {
  return (
    <div className="w-full h-full flex items-center justify-center flex-col gap-12">
      <img
        src={nullData}
        alt=""
        style={{
          width: '300px',
          height: '260px',
          marginTop: '-80px',
        }}
      />
      <div
        style={{
          fontWeight: '500',
          fontSize: '16px',
          color: '#000000',
        }}
      >
        暂无数据
      </div>
    </div>
  )
}
export default function (props) {
  return (
    <div className="h-full flex flex-1 flex-col relative">
      <AutoResizer>
        {({ width, height }) => (
          <Table width={width} height={height} {...props} />
        )}
      </AutoResizer>
    </div>
  )
}

const DEFAULT_HEIGHT = 45

const DraggableContainer = SortableContainer(({ children }) => children)
const DraggableElement = SortableElement(({ children }) => children)
const DraggableHandle = SortableHandle(({ children }) => children)

const Row = ({ slug, index, children, ...rest }) => {
  return (
    <DraggableElement key={slug} index={index}>
      <div {...rest}>
        <DraggableHandle>
          <DragHandle />
        </DraggableHandle>
        {children}
      </div>
    </DraggableElement>
  )
}

const Header = ({ children, ...rest }) => {
  return (
    <div {...rest}>
      <div style={{ width: 10 }} />
      {children}
    </div>
  )
}

// 参数过多？？
const Table = function ({
  fields,
  rowHeight,
  tbData,
  mergeCellInfo,
  selectedIds,
  defaultSorts,
  width,
  height,
  config,
  isShowSelections,
  onChangeSelected,
  onChangeSorts,
  onChangeOrder,
  beforeTransform,
  afterTransform,
  showTbDetail,
  createTbData,
  destroyTbData,
  showTbInlineEdit,
  showOperation,
  recoverTbData,
  switchDataNextOrPrev,
  updateMarkImg,
  onFetchRemoteData,
  onShowStatistics,
  onCloumnOperate,
  operatorConfig,
  OperateComponent,
  FixedOperateComponent,
  inlineEdit,
  showFixedOperation,
  isRenderOperateTable = true,
  iSestimatedRowHeight,
  className,
  renderRowClass,
  isDraggable,
  fixedOperationWidth,
  operatorNum,
  dataCheckDisabled,
}) {
  const { toggleCheckAll, maskedData, toggleCheck } = useDittoSelected({
    onChangeSelected,
    tbData,
    selectedIds,
    dataCheckDisabled,
  })

  const TransedFieldsDefs = transformTableFieldsDefs(
    fields,
    { tbWidth: width, ...config, mergeCellInfo, isShowSelections, isDraggable },
    {
      beforeTransform,
      afterTransform,
      showTbDetail,
      createTbData,
      destroyTbData,
      recoverTbData,
      switchDataNextOrPrev,
      updateMarkImg,
      showTbInlineEdit,
      onShowStatistics,
      onCloumnOperate,
      onFetchRemoteData,
      toggleCheck,
      toggleCheckAll,
      // 存值
      selectedIds,
      dataCheckDisabled,
    },
    {
      isRenderOperateTable,
      showFixedOperation,
      operatorNum,
      fixedOperationWidth,
      dataCheckDisabled,
    }
  )

  const memodFieldsDefs = useMemo(TransedFieldsDefs, [
    fields,
    config,
    maskedData,
    mergeCellInfo,
    dataCheckDisabled,
  ])

  const tableRef = useRef()

  const handleEndReached = () => {
    // tbDataControl.appendNextPage()
    console.log('end')
  }

  // const finalMergeDataInfo = transformMergeCellInfo(mergeCellInfo)
  const mergerDataInfo = transformMergeCellInfo(mergeCellInfo)

  const customMergerDataInfo = calculationMergeCellInfo(mergeCellInfo)

  const rowRenderer = useCallback(
    ({ rowData, cells, columns }) => {
      // 若该条数据需要处理合并
      if (mergerDataInfo[rowData.objectId]) {
        const isUnEven = !(
          customMergerDataInfo[rowData.objectId] &&
          customMergerDataInfo[rowData.objectId].even
        )
        mergerDataInfo[rowData.objectId].forEach((item, n) => {
          const { slug } = item
          const index = findIndex(columns, (v) => v.key === slug)
          if (columns[index] && columns[index].colSpan) {
            const colSpan = columns[index].colSpan(
              rowData.objectId,
              mergerDataInfo
            )
            if (colSpan > 1 && cells[index]) {
              // eslint-disable-next-line prefer-destructuring
              let cellWidth = cells[index].props.style.width
              for (let i = 1; i < colSpan; i++) {
                cellWidth += cells[index + i].props.style.width
                cells[index + i] = null
              }
              const style = {
                ...cells[index].props.style,
                width: cellWidth,
                backgroundColor:
                  index !== 0 && isUnEven && renderRowClass
                    ? 'var(--ow-color-neutral-300)'
                    : '#fff',
                borderLeft: '1px solid #eef0f2',
                borderRight:
                  n < mergerDataInfo.length - 1 &&
                  mergerDataInfo.find((v) => v.index === item.index + 1)
                    ? ''
                    : '1px solid #eef0f2',
              }
              cells[index] = React.cloneElement(cells[index], {
                style,
              })
            }
          }
        })
      }

      // 若该条数据需要处理合并
      if (mergerDataInfo[rowData.objectId]) {
        const isUnEven = !(
          customMergerDataInfo[rowData.objectId] &&
          customMergerDataInfo[rowData.objectId].even
        )
        // 处理需要行合并的列slug
        mergerDataInfo[rowData.objectId].forEach((item, i) => {
          const { slug } = item
          const index = findIndex(columns, (v) => v.key === slug)
          if (index > -1 && columns[index] && columns[index].rowSpan) {
            const rowSpan = columns[index].rowSpan(
              rowData.objectId,
              mergerDataInfo
            )
            if (rowSpan > 1 && cells[index]) {
              // 当前要跨行的cell
              const cell = cells[index]
              const style = {
                ...cells[index].props.style,
                backgroundColor:
                  index !== 0 && isUnEven && renderRowClass
                    ? 'var(--ow-color-neutral-300)'
                    : '#fff',
                height: rowSpan * (rowHeight || DEFAULT_HEIGHT),
                alignSelf: 'flex-start',
                borderLeft: '1px solid #eef0f2',
                borderRight:
                  i < mergerDataInfo.length - 1 &&
                  mergerDataInfo.find((v) => v.index === item.index + 1)
                    ? ''
                    : '1px solid #eef0f2',
                borderBottom: rowSpan > 1 ? '1px solid #eef0f2' : '',
                zIndex: 1,
              }
              cells[index] = React.cloneElement(cell, { style })
            }
          }
        })
      }
      return cells
    },
    [customMergerDataInfo, mergerDataInfo, renderRowClass]
  )

  const rowClassName = React.useCallback(
    ({ rowData }) => {
      if (renderRowClass) {
        if (
          !(
            rowData &&
            customMergerDataInfo[rowData.objectId] &&
            customMergerDataInfo[rowData.objectId].even
          ) &&
          mergerDataInfo[rowData.objectId]
        ) {
          return 'sticky-row'
        }
        return ''
      }
      return null
    },
    [customMergerDataInfo, mergerDataInfo, renderRowClass]
  )

  const tableProps = {}
  if (iSestimatedRowHeight) {
    tableProps.estimatedRowHeight = rowHeight || DEFAULT_HEIGHT
  } else {
    tableProps.rowHeight = rowHeight || DEFAULT_HEIGHT
  }
  if (renderRowClass) {
    tableProps.rowClassName = rowClassName
  }

  const getFrozenLeft = () => memodFieldsDefs.some((f) => f.frozen === 'left')

  const getContainer = () => {
    return tableRef.current
      ?.getDOMNode()
      .querySelector(
        getFrozenLeft()
          ? '.BaseTable__table-frozen-left .BaseTable__body'
          : '.BaseTable__body'
      )
  }

  const getHelperContainer = () => {
    return tableRef.current
      ?.getDOMNode()
      .querySelector(
        getFrozenLeft() ? '.BaseTable__table-frozen-left' : '.BaseTable__table'
      )
  }

  const checkRowDraggable = (columns) => {
    if (!isDraggable) return false

    if (getFrozenLeft()) {
      return columns.every((c) => c.frozen === 'left')
    }
    return columns.every((c) => !c.frozen || c.frozen === 'right')
  }

  const rowProps = ({ rowIndex, rowData, columns }) => {
    return {
      tagName: checkRowDraggable(columns) ? Row : undefined,
      index: rowIndex,
      slug: rowData.objectId,
    }
  }

  const headerProps = ({ columns }) => {
    return {
      tagName: checkRowDraggable(columns) ? Header : undefined,
    }
  }

  useEffect(() => {
    if (tableRef.current && tableRef.current.recomputeGridSize) {
      tableRef.current.recomputeGridSize()
    }
  }, [rowHeight])

  return (
    <ListStoreProvider
      operatorConfig={operatorConfig}
      fields={fields}
      OperateComponent={OperateComponent}
      FixedOperateComponent={FixedOperateComponent}
      showFixedOperation={showFixedOperation}
      inlineEdit={inlineEdit}
    >
      <DraggableContainer
        getContainer={getContainer}
        helperContainer={getHelperContainer}
        onSortEnd={onChangeOrder}
        useDragHandle
      >
        <BaseTableStyld>
          <BaseTable
            ref={tableRef}
            fixed
            columns={memodFieldsDefs}
            data={maskedData}
            width={width}
            height={height}
            components={Renders}
            headerHeight={DEFAULT_HEIGHT}
            onEndReached={handleEndReached}
            sortState={defaultSorts}
            onColumnSort={({ key, order }) => {
              onChangeSorts({
                slug: key,
                order,
              })
            }}
            rowKey="objectId"
            rowRenderer={mergeCellInfo && rowRenderer}
            // overscanRowCount={10}
            showOperation={showOperation}
            rowProps={rowProps}
            headerProps={headerProps}
            className={className}
            emptyRenderer={<RenderNullData />}
            getScrollbarSize={() => {
              return 9.6
            }}
            {...tableProps}
          />
        </BaseTableStyld>
      </DraggableContainer>
    </ListStoreProvider>
  )
}
